import { useFieldArray, useFormContext } from 'react-hook-form';

import { Divider, Grid, IconButton, Stack, Tooltip } from '@mui/material';

import { IcClose } from '@/assets/images';
import { RenderFormField } from '@/components';
import { Button } from '@/components/TailwindComponents';
import { OptionType } from '@/pages/CFS/Edit/components/CFSForm';
import { colors } from '@/theme/variables';

import AdditionalInfoRelated from './AdditionalInfoRelated';
import { informationTypesItems } from '../data';

export const AdditionanInformationForm = () => {
  const { control, watch, getValues } = useFormContext();
  const { remove, append, fields } = useFieldArray({
    control,
    name: 'informationType',
  });

  const currentInformationType = watch('informationType');
  const addAditionalInformationType = () => {
    append({});
  };

  const selectableTypesCount = informationTypesItems.filter(
    (item) => item.value !== '0',
  ).length;
  const allTypesAdded = fields.length >= selectableTypesCount;

  return (
    <>
      {fields.map((item, index) => (
        <Stack key={item.id} mt={1} mb={2}>
          <Grid container>
            {currentInformationType && currentInformationType[index] && (
              <Grid item>
                <Tooltip title="delete this section">
                  <IconButton
                    onClick={() => remove(index)}
                    sx={{
                      color: colors.error.main,
                      mt: 3,
                      alignSelf: 'flex-start',
                    }}
                  >
                    <IcClose />
                  </IconButton>
                </Tooltip>
              </Grid>
            )}
            <Grid item md={3}>
              <RenderFormField
                name={`informationType.${index}.name`}
                label="Information type"
                type="select"
                placeholder="choose information type"
                items={informationTypesItems
                  .filter((additionalItem) => additionalItem.value !== '0')
                  .map((additionalItem) => {
                    return !currentInformationType?.find(
                      (infoType: { name: string }) =>
                        infoType?.name === additionalItem.value,
                    )
                      ? additionalItem
                      : { ...additionalItem, disabled: true };
                  })}
                defaultValue={
                  '' as (string | number | readonly string[]) & OptionType
                }
                disabled={
                  getValues(currentInformationType[index]?.name)?.length &&
                  !!currentInformationType[index]?.name
                }
              />
            </Grid>
            <Grid item flex="1">
              {currentInformationType &&
                currentInformationType[index] &&
                !!currentInformationType[index].name && (
                  <AdditionalInfoRelated
                    currentSelection={currentInformationType[index].name}
                    control={control}
                    index={index}
                    onRemoveLast={() => remove(index)}
                  />
                )}
            </Grid>
          </Grid>

          <Divider />
        </Stack>
      ))}
      {!allTypesAdded && (
        <Button
          color="error"
          type="button"
          size="sm"
          variant="secondary"
          className="text-sm w-fit"
          onClick={addAditionalInformationType}
        >
          + Add new
        </Button>
      )}
    </>
  );
};
